import { render, staticRenderFns } from "./UpdateBanner.vue?vue&type=template&id=04f2dcb6&scoped=true"
import script from "./UpdateBanner.vue?vue&type=script&lang=js"
export * from "./UpdateBanner.vue?vue&type=script&lang=js"
import style0 from "./UpdateBanner.vue?vue&type=style&index=0&id=04f2dcb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f2dcb6",
  null
  
)

export default component.exports